"use strict";

exports.__esModule = true;
exports["default"] = exports.TabsProvider = exports.TabsContext = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TabsContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.TabsContext = TabsContext;
var TabsProvider = function TabsProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)('list'),
    selectedTab = _useState[0],
    setSelectedTab = _useState[1];
  var showList = selectedTab === 'list';
  var showMap = selectedTab === 'map';
  return /*#__PURE__*/_react["default"].createElement(TabsContext.Provider, {
    value: {
      selectedTab: selectedTab,
      setSelectedTab: setSelectedTab,
      showList: showList,
      showMap: showMap
    }
  }, children);
};
exports.TabsProvider = TabsProvider;
/**
 * @returns {{
 * selectedTab: string
 * setSelectedTab: function
 * showList: boolean
 * showMap: boolean
 * }} object
 */
var useTabs = function useTabs() {
  return (0, _react.useContext)(TabsContext);
};
var _default = useTabs;
exports["default"] = _default;